export const BASE_URL = process.env.REACT_APP_API_BASE_URL!;

export const API_ENDPOINTS = {
  LOGIN: "/auth/login",
  ADMINS: "/admins",
  MODERATORS: "/moderators",
  CATEGORIES: "/categories",
  SUBCATEGORY_IMAGE: "/subcategory_image",
  SUBCATEGORY_INFO: "/subcategory_info",
  TWILIO: "/twilio",
  SEND_VERIFICATION_CODE: "/send_verification_code",
  CHECK_VERIFICATION_CODE: "/check_verification_code",
  CATEGORIES_UNLOCK_CODES: "/category_unlock_codes",
  STATS: "/stats",
  RATINGS: "/ratings",
  ATTACHMENT: "/attachment",
  CORRECT_ANSWERS_PERCENTAGE: "/correct_answers_percentage",
  AVERAGE_TIME_TAKEN_TO_ANSWER: "/average_time_taken_to_answer",
  ACCESSIBLE_BY_LIST: "/accessible_by_list",
  ORDERS: "/orders",
  QUESTIONS: "/questions",
  LISTED: "/listed",
  QUESTIONS_1v1: "/questions_1v1",
  ANSWERS: "/answers",
  GAMES: "/games",
  CUSTOM_GAMES: "/custom_games",
  GAMES_1V1: "/games_1v1",
  QUESTION_ID: "/question_id",
  PLAYERS: "/players",
  LOGS: "/logs",
  SEARCH: "/search",
  PACKAGES: "/packages",
  DISCOUNT_CODES: "/discount_codes",
  IN_BULK: "/in_bulk",
  TRANSACTIONS: "/transactions",
  QUESTIONS_ANSWERS: "/questions_answers",
  FILTERED: "/filtered",
  FILTER: "/filter_by",
  NOTIFICATIONS: "/notifications",
  POPUPS: "/popups",
  UPLOAD_FILE: "/upload_file",
};
